import { render, staticRenderFns } from "./SectionObservations.vue?vue&type=template&id=6608fb33&scoped=true"
import script from "./SectionObservations.vue?vue&type=script&lang=js"
export * from "./SectionObservations.vue?vue&type=script&lang=js"
import style0 from "./SectionObservations.vue?vue&type=style&index=0&id=6608fb33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608fb33",
  null
  
)

export default component.exports